const initialState = {
  startDate: null,
  endDate: null,
  tipAmount: 0,
  review: "",
  teamMembers: [],
};

export const teamTipReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TEAM_TIP_DATA":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
